module.exports = __webpack_public_path__ + "static/media/replica-google-keep.c9afc4cf.jpg";